import { render, staticRenderFns } from "./WidgetEmployeeTaskCountLast3Month.vue?vue&type=template&id=4224ea33&"
import script from "./WidgetEmployeeTaskCountLast3Month.vue?vue&type=script&lang=js&"
export * from "./WidgetEmployeeTaskCountLast3Month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports